/**
 * insuranceAlerts.js
 * Avisos de documentação do convênio que a API devolve em cada agendamento
 * (`insurance_alerts`, regra em public/api/appointments/InsurancePendencies.php).
 *   critical: falta algo para atender pelo convênio (guia negada, carteirinha vencida...)
 *   info:     aviso, não pendência: ainda vale, mas vence até 30 dias depois do atendimento
 *             (fica fora de "Convênios a conferir" quando é o único aviso)
 */

export const ALERT_CRITICAL = 'critical';
export const ALERT_INFO = 'info';

// Documento já na ficha, só falta vincular ao atendimento (o remédio é "Vincular documento")
const UNLINKED_CODES = ['request_unlinked', 'authorization_unlinked'];

export function isUnlinkedAlert(alert) {
  return UNLINKED_CODES.includes(alert?.code);
}

export function insuranceAlertsOf(appointment) {
  return Array.isArray(appointment?.insurance_alerts) ? appointment.insurance_alerts : [];
}

export function hasCriticalAlert(alerts) {
  return (alerts || []).some((alert) => alert.level === ALERT_CRITICAL);
}

/** Críticos primeiro, na ordem que a API mandou */
export function sortAlerts(alerts) {
  return [...(alerts || [])].sort((a, b) => (a.level === b.level ? 0 : a.level === ALERT_CRITICAL ? -1 : 1));
}

/** Texto curto para tooltip: uma linha por aviso */
export function alertsTitle(alerts) {
  return sortAlerts(alerts).map((alert) => alert.message).join('\n');
}
